export const StringBoolean = {
  true: 'true',
  false: 'false',
};
